import http from 'plugins/axios';

export default {
    getUserMiningConfigList(data) {
        return http.get({
            url: '/admin/mining/config/list',
            data: data
        });
    },

    createOrUpdateMiningConfig(data) {
        return http.post({
            url: '/admin/mining/config/createOrUpdate',
            data: data,
            dataType: 'form'
        });
    },

    updateMiningConfigShowed(data) {
        return http.post({
            url: '/admin/mining/config/updateShowed',
            data: data,
            dataType: 'form'
        });
    },

    updateMiningConfigStatus(data) {
        return http.post({
            url: '/admin/mining/config/updateStatus',
            data: data,
            dataType: 'form'
        });
    },

    adminUnLockUserMining(data) {
        return http.post({
            url: '/admin/mining/config/unLockUserMining',
            data: data,
            dataType: 'form'
        });
    },

    deleteUserMiningConfig(data) {
        return http.post({
            url: '/admin/mining/config/delete',
            data: data,
            dataType: 'form'
        });
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
